import { cn } from '../utils/cn';

export const MopSparklesIcon = (props: React.ComponentProps<'svg'>) => {
  const { className, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('size-4', className)}
      {...rest}
    >
      <path d="M10 22a3 3 0 01-3-3" />
      <path d="M10 22c2.761 0 5-1.79 5-4-4.42 0-4.08-5-8.5-5a4.501 4.501 0 000 9z" />
      <path d="M10 3H8" />
      <path d="M12.5 11.5 22 2" />
      <path d="M20 13v4" />
      <path d="M22 15h-4" />
      <path d="M4 5v4" />
      <path d="M6 7H2" />
      <path d="m6.98 13.02 2.665-2.664a1.21 1.21 0 011.71 0l2.29 2.288a1.21 1.21 0 010 1.712l-2.088 2.087" />
      <path d="M9 2v2" />
    </svg>
  );
};
